<!--
 * @description: 科普殿堂
 * @Author: Jay
 * @Date: 2021-09-17 11:31:21
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 14:30:50
-->
<template>
  <div>
    <!-- 顶部 背景 标题 -->
    <bg-img-top
      :bgImg="$api + reData.image"
      EnTitle="Science Popularization Palace"
      title="科普殿堂"
      v-if="reData != ''"
    ></bg-img-top>
    <!-- 页面内容 -->
    <div class="fix-width">
      <div v-class="'animate__animated animate__fadeInUp'">
        <!-- tab切换 -->
        <div class="carousel-top padding-sm flex justify-center">
          <ul class="tab-ul" v-for="(item, index) in reData.data" :key="index">
            <li class="font_size_xl padding-left-sm" @click="selectTab(index)">
              <span
                class="cuIcon-title text-yellow"
                v-show="tabIndex == index"
              ></span>
              <span class="text-black padding-left-xs">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 内容列表 -->
      <div class="margin-top">
        <palace-list-code
          :codeData="reData.data[tabIndex].article"
          v-if="reData != ''"
        ></palace-list-code>
      </div>
      <!-- 分页 -->
      <!-- <div class="margin-top text-align">
        <el-pagination background layout="prev, pager, next" :total="10">
        </el-pagination>
      </div> -->
    </div>
    <!-- 底部边距 -->
    <div class="margin-top margin-bottom"></div>
  </div>
</template>

<script>
// 顶部 背景 标题
import bgImgTop from "@/components/tab/bg-img-top.vue";
// 内容列表
import PalaceListCode from "../../components/code/palace-list-code.vue";
import { palace } from "../../api/api";
export default {
  name: "Palace",
  data() {
    return {
      //当前选中
      tabIndex: 0,
      //请求数据
      reData: [],
    };
  },
  components: {
    bgImgTop,
    PalaceListCode,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 科普殿堂
      palace().then((res) => {
        // console.log(res);
        this.reData = res.data;
      });
    },
    //tab切换
    selectTab(e) {
      //   console.log(e);
      this.tabIndex = e;
    },
  },
  watch: {
    // 监听路由 值
    "$route.query.index"(newval) {
      // console.log("监听路由 值", newval, olval);
      this.selectTab(newval);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>